import React from "react";

const ContactSupport: React.FC = () => {
  return (
    <div>
      <div className="p-4 md:px-[15vw] md:pt-[5vh] w-full flex flex-col font-normal text-sm space-y-5 text-black">
        <div>
          {/* <p className="flex items-start text-[1.65vh] text-customGrayBase">
            Last updated: 10/22/2024
          </p> */}
          <h1 className="mt-[4%] font-helveticaBold text-[5.5vh] xxl:text-[7.5vh] leading-none text-black">
            Afrocart Contact <br /> Support
          </h1>
        </div>
        <p>
          At <span className="font-helveticaBold">Afrocart</span>, we are here
          to assist you with any questions or concerns you may have. Our
          dedicated customer support team is always ready to provide the help
          you need.
        </p>
        <ol className="decimal_ol space-y-4">
          <li className="font-helveticaBold text-black">
            How to Reach Us
            <p className="font-helvetica text-black">
              You can contact us through the following channels:
              <ul className="font-helvetica disc_li space-y-2">
                <li>
                  Email:{" "}
                  <a href="mailto:admin@afrocart.ca" className="text-blue-500">
                    admin@afrocart.ca
                  </a>
                </li>
                <li>
                  Phone:{" "}
                  <span className="font-helveticaBold">+1289-460-1541</span>{" "}
                  (Mon-Fri, 9 am - 6 pm)
                </li>
                <li>
                  Live Chat: Available on our website during business hours
                </li>
              </ul>
            </p>
          </li>

          <li className="font-helveticaBold text-black">
            Frequently Asked Questions
            <p className="font-helvetica text-black">
              Before reaching out, you might find the answer to your question in
              our{" "}
              <a href="/faqs" className="text-blue-500">
                FAQ section
              </a>
              . We have compiled answers to the most commonly asked questions
              for your convenience.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Response Time
            <p className="font-helvetica text-black">
              Our support team strives to respond to all inquiries within 24
              hours. During peak times, responses may take a bit longer, but
              rest assured, we are working hard to get back to you as soon as
              possible.
            </p>
          </li>
          <li className="font-helveticaBold text-black">
            Feedback
            <p className="font-helvetica text-black">
              We value your feedback and suggestions. If you have ideas for
              improving our services or website, please let us know! Your input
              helps us serve you better.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default ContactSupport;
